import { GetResourcePermissionMasterCacheKey } from "../../Identity/hooks/useGetResourcePermission";
import { ListSubjectsWithRelationMasterCacheKey } from "../../Identity/hooks/useListSubjectsWithRelation";
export default async function clearPermissionCaches(queryClient) {
    // The removeQueries method can be used to remove queries from the cache based on their query keys or any other functionally accessible property/state of the query.
    queryClient.removeQueries({
        queryKey: [ListSubjectsWithRelationMasterCacheKey],
    });
    // The invalidateQueries method can be used to invalidate and refetch single or multiple queries in the cache based on their query keys or any other functionally accessible property/state of the query. By default, all matching queries are immediately marked as invalid and active queries are refetched in the background.
    await queryClient.invalidateQueries({
        queryKey: [ListSubjectsWithRelationMasterCacheKey],
    });
    queryClient.removeQueries({
        queryKey: [GetResourcePermissionMasterCacheKey],
    });
    await queryClient.invalidateQueries({
        queryKey: [GetResourcePermissionMasterCacheKey],
    });
}
//# sourceMappingURL=utils.js.map